module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiPgogIDxwYXRoIGQ9Ik05NjcuNDggMGgtOTExQzI1LjI4LjAyLS4wMSAyNS4zMiAwIDU2LjUydjkxMWMuMDIgMzEuMiAyNS4zMiA1Ni40OCA1Ni41MiA1Ni40OEg1NDdWNjI4SDQxNFY0NzNoMTMzVjM1OWMwLTEzMi4yNiA4MC43Ny0yMDQuMjggMTk4Ljc2LTIwNC4yOCA1Ni41MSAwIDEwNS4wOCA0LjIxIDExOS4yNCA2LjA5VjI5OWgtODEuNjJjLTY0IDAtNzYuMzggMzAuNDktNzYuMzggNzUuMjNWNDczaDE1My40OWwtMjAgMTU1SDcwN3YzOTZoMjYwLjQ4YzMxLjIxLjAxIDU2LjUxLTI1LjI5IDU2LjUyLTU2LjVWNTYuNDhjLS4wMi0zMS4yLTI1LjMyLTU2LjQ5LTU2LjUyLTU2LjQ4eiIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_facebook.svg
// module id = 197
// module chunks = 1